import { createSlice } from '@reduxjs/toolkit';

export const geoSubdomainSlice = createSlice({
  name: 'geoSubdomain',
  initialState: 'www',
  reducers: {},
});

export const { reducer: geoSubdomainReducer } = geoSubdomainSlice;
